const Schedule = () => {
    return (
        <div>
            <p>This is Schedule page</p>
        </div>
    )
}

export default Schedule